import classNames from "classnames";
import type { HTMLAttributes } from "react";
import { forwardRef } from "react";

type SpanAttributes = HTMLAttributes<HTMLSpanElement>;

const typographyGenerator = (className: string) => {
  return forwardRef<HTMLSpanElement, SpanAttributes>(function Typography(
    props,
    ref
  ) {
    return (
      <span
        {...props}
        ref={ref}
        className={classNames(className, props.className)}
      />
    );
  });
};

export const BodySmall = typographyGenerator("text-sm");
export const BodyMedium = typographyGenerator("text-md");
export const BodyLarge = typographyGenerator("text-lg");
export const BodyXLarge = typographyGenerator("text-xl");

export const DisplaySmall = typographyGenerator("typesetting-display-sm");
export const DisplayTitle = typographyGenerator("typesetting-display-title");

export const TextXSmall = typographyGenerator("text-xs");
export const TextSmall = typographyGenerator("type-sm");
export const TextMedium = typographyGenerator("text-md");
export const TextLarge = typographyGenerator("text-lg");
